import { GeoPoint } from '@core/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CityState, StateWithCity } from '../city-state';
import { getCityState } from './feature.selector';

export const getGeoPointState: MemoizedSelector<StateWithCity, GeoPoint> = createSelector(
  getCityState,
  (state: CityState) => state.userGeoPoint,
);
